import React, { Component } from "react";
import axios from "axios";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import SendInvoice from "./SendInvoice";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import Spinner from "../layout/Spinner";

export default class InvoicePDF extends Component {
	constructor(props) {
		super(props);

		this.state = {
			invoice: {},
			company: {},
			yards: [],
			yardSum: 0,
			subtotal: 0,
			showModalEmail: false,
			showModalSms: false,
			trip: 0,
			loadsData: {},
			pdf: "",
			loading: true,
		};
	}

	/**
	 * Get company information
	 */
	// getCompanyInfo = async () => {
	// 	const url = api + "/company";
	// 	const token = localStorage.getItem("token");
	// 	axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

	// 	try {
	// 		const { data } = await axios.get(url);
	// 		this.setState({
	// 			company: data,
	// 		});
	// 	} catch (err) {
	// 		console.error(err);
	// 		return null;
	// 	}
	// };

	/**
	 * Get PDF invoice
	 */
	getPDFInvoice = async () => {
		const url = api + `/invoicepdf/57Concrete/${this.props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			console.log(data);
			this.setState({
				pdf: data,
				loading: false,
			});
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	/**
	 * Open and close email modal
	 * @param {Event} e event of the modal
	 */
	toggleModalEmail = (e) => {
		this.setState({
			showModalEmail: !this.state.showModalEmail,
		});
	};

	/**
	 * Open and close sms modal
	 * @param {Event} e event of the modal
	 */
	toggleModalSms = (e) => {
		this.setState({
			showModalSms: !this.state.showModalSms,
		});
	};

	componentDidMount() {
		this.getPDFInvoice();
	}

	render() {
		return (
			<Layout
				title="Invoice PDF"
				description="Invoice"
				className="container col-md-12"
			>
				<Link
					onClick={this.toggleModalEmail}
					to="#"
					className="btn btn-primary"
				>
					Send invoice by email
				</Link>
				<Link
					onClick={this.toggleModalSms}
					to="#"
					className="btn btn-success"
					style={{ marginLeft: 20 }}
				>
					Send invoice by SMS
				</Link>
				<Modal
					show={this.state.showModalEmail}
					animation={false}
					onHide={this.toggleModalEmail}
				>
					<Modal.Header closeButton>
						<Modal.Title>Send Invoice to:</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<SendInvoice
							invoiceId={this.props.match.params.id}
							pcallback={this.toggleModalEmail}
							isEmail={true}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={this.state.showModalSms}
					animation={false}
					onHide={this.toggleModalSms}
				>
					<Modal.Header closeButton>
						<Modal.Title>Send Invoice to:</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<SendInvoice
							invoiceId={this.props.match.params.id}
							pcallback={this.toggleModalSms}
							isEmail={false}
						/>
					</Modal.Body>
				</Modal>

				{this.state.loading ? (
					<Spinner />
				) : (
					<iframe src={this.state.pdf} width="95%" style={{ height: "90vh" }} />
				)}
			</Layout>
		);
	}
}
